import { Switch } from '@mui/material';
import { CustomCellRendererProps } from 'ag-grid-react';

/**
 * A cell renderer that displays a boolean value as an MUI Switch toggle.
 * Handles value changes directly via the grid API, bypassing the edit mode
 * for a seamless single-click toggle experience.
 *
 * For group rows, the switch reflects the aggregated value (via aggFunc) and
 * toggling it applies the new value to every filtered leaf descendant, using
 * ag-grid v35's native node.getAggregatedChildren API.
 */
export function EditableBooleanFieldRenderer(props: CustomCellRendererProps<unknown, boolean>) {
  const { node } = props;
  const field = props.column!.getColDef().field ?? props.column!.getColId();

  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (node.group) {
      node.getAggregatedChildren(field, true).forEach((child) => {
        child.setDataValue(field, checked);
      });
    } else {
      node.setDataValue(field, checked);
    }
  };

  return <Switch checked={props.value ?? false} onChange={handleChange} size='small' />;
}
